import { render, staticRenderFns } from "./Userstable.vue?vue&type=template&id=64db1595&"
import script from "./Userstable.vue?vue&type=script&lang=js&"
export * from "./Userstable.vue?vue&type=script&lang=js&"
import style0 from "./Userstable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports